import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { Nullable } from '../../types/common'

const MIN_RANGE_NUMBER_SELECTOR = `[data-price-min-range-number]`
const MAX_RANGE_NUMBER_SELECTOR = `[data-price-max-range-number]`
const RANGE_INPUTS_WRAPPER_SELECTOR = `[data-price-range-inputs-wrapper]`
const MIN_RANGE_INPUT_SELECTOR = `[data-price-min-range-input]`
const MAX_RANGE_INPUT_SELECTOR = `[data-price-max-range-input]`
const PRICE_RANGE_PROGRESS_SELECTOR = `[data-price-range-progress]`

export class PriceRange extends BaseComponent {
  minNumberInput: Nullable<HTMLInputElement>
  maxNumberInput: Nullable<HTMLInputElement>
  rangeWrapper: Nullable<HTMLElement>
  minRangeInput: Nullable<HTMLInputElement>
  maxRangeInput: Nullable<HTMLInputElement>
  progress: Nullable<HTMLElement>
  currencyWithoutDecimals: boolean | undefined
  numbersAfterComma: number

  constructor() {
    super()
    this.minNumberInput = $el(MIN_RANGE_NUMBER_SELECTOR, this)
    this.maxNumberInput = $el(MAX_RANGE_NUMBER_SELECTOR, this)
    this.rangeWrapper = $el(RANGE_INPUTS_WRAPPER_SELECTOR, this)
    this.minRangeInput = $el(MIN_RANGE_INPUT_SELECTOR, this)
    this.maxRangeInput = $el(MAX_RANGE_INPUT_SELECTOR, this)
    this.progress = $el(PRICE_RANGE_PROGRESS_SELECTOR, this)
  }

  mountComponent(): void {
    if (this.minRangeInput) {
      this.updateMinRangeInput(+this.minRangeInput.value)
      this.updateMinPriceInput(+this.minRangeInput.value)
    }

    if (this.maxRangeInput) {
      this.updateMaxRangeInput(+this.maxRangeInput.value)
      this.updateMaxPriceInput(+this.maxRangeInput.value)
    }

    this.addListener(this.minNumberInput, 'input', this.handleNumberChange)
    this.addListener(this.maxNumberInput, 'input', this.handleNumberChange)
    this.addListener(this.minRangeInput, 'input', this.handleRangeChange)
    this.addListener(this.maxRangeInput, 'input', this.handleRangeChange)
    this.addListener(this.rangeWrapper, 'mouseenter', this.handleRangeInput)
    this.addListener(this.rangeWrapper, 'mousemove', this.handleRangeInput)
  }

  handleRangeInput = (event: MouseEvent): void => {
    const maxInput = $el(`[data-price-range-max-input]`, this)
    const minInput = $el(`[data-price-range-min-input]`, this)

    if (this.progress && minInput && maxInput) {
      const middleOfProgress =
        this.progress.offsetLeft + this.progress.offsetWidth / 2
      const isMinInputClosest = event.offsetX < middleOfProgress

      minInput.toggleAttribute('targeted', isMinInputClosest)
      maxInput.toggleAttribute('targeted', !isMinInputClosest)
    }
  }

  handleNumberChange = (): void => {
    if (this.minNumberInput && this.maxNumberInput) {
      const minPrice = parseFloat(this.minNumberInput.value)
      const maxPrice = parseFloat(this.maxNumberInput.value)

      this.updateMinRangeInput(minPrice)
      this.updateMaxRangeInput(maxPrice)
    }
  }

  handleRangeChange = (): void => {
    if (this.minRangeInput && this.maxRangeInput) {
      const minVal = parseFloat(this.minRangeInput.value)
      const maxVal = parseFloat(this.maxRangeInput.value)

      this.updateMaxPriceInput(maxVal)
      this.updateMaxRangeInput(maxVal)

      this.updateMinPriceInput(minVal)
      this.updateMinRangeInput(minVal)
    }
  }

  updateMaxRangeInput(newValue: number): void {
    const value = Math.ceil(newValue)

    if (this.maxRangeInput && this.progress) {
      const rightPosition = 100 - (value / +this.maxRangeInput.max) * 100

      this.maxRangeInput.value = `${value}`
      this.progress.style.right = `${rightPosition}%`
    }
  }

  updateMinRangeInput(newValue: number): void {
    const value = Math.ceil(newValue)

    if (this.minRangeInput && this.progress) {
      this.minRangeInput.value = `${value}`
      this.progress.style.left = `${(value / +this.minRangeInput.max) * 100}%`
    }
  }

  updateMaxPriceInput(newValue: number): void {
    const value = Math.ceil(newValue)

    if (this.maxNumberInput) {
      this.maxNumberInput.value = value.toFixed(0)
    }
  }

  updateMinPriceInput(newValue: number): void {
    const value = Math.ceil(newValue)

    if (this.minNumberInput) {
      this.minNumberInput.value = value.toFixed(0)
    }
  }
}
